import Vue from 'vue';

const LABELS = ['product_image', 'campaign_name', 'shipping_price', 'redirect_link']
let getLabel = function(index) {
  return LABELS[index] || false
}

let getSelectorTemplate = function() {
  return {
    'campaign_name'     : [],
    'shipping_price'    : [],
    'product_image'     : [],
    'redirect_link'     : []
  }
}

/**
 *
 * Data structure for rotator's state:
 *   {
 *     product_image: [{ s: <selector>, i: <step> } [, ... ]],
 *     campaign_name: [{ s: <selector>, c: <content>, i: <step> } [, ... ]],
 *     ...
 *   }
 **/
export default {
  getters: {
    isSdkValid(state, getters) {
      return state.sdkDetected &&
        (state.sdkDetected.template_id === state.template_id && state.sdkDetected.rotator_id === state.rotator_id)
    },
    rotatorBaseEndpoint(state, getters, rootState, rootGetters) {
      return rootGetters.affiliateBaseEndpoint + '/rotator/' + state.rotator_id;
    },
    templateBaseEndpoint(state, getters) {
      return getters.rotatorBaseEndpoint + '/template/' + state.template_id;
    },
    sdk: (state, getters) => () => {
      return `<script id="jbo-rotator" type="text/javascript">
      /** Rotator Script **/
      !function(a,b,c,d){"use strict";function e(a){var c=b.cookie.match("\\\\b"+a+"=([^;]*)\\\\b");return c?c[1]:void 0}if(!a.jbo||!/^2/.test(a.jbo.version)){a.jbo&&(a.jbo.destroyed=!0,a.jbo("destroy"));var f=Math.floor((new Date).getTime()/1e3),g=g||(parseInt(e(c+"_lifetime"),10)>=f?e(c):"")||"",h=/(\\?|&)(lt|livetest)=/gi.test(a.location.search)?"&livetest=1":"",i=(b.location.protocol,b.createElement("script")),j=b.getElementsByTagName("script"),k=j[j.length-1],l=a.jbo=function(){l.callMethod?l.callMethod.apply(l,arguments):l.queue.push(arguments)};l.push=jbo,l.execStart=(new Date).getTime(),l.script=b.currentScript||b.getElementById("jbo-rotator"),l.loaded=!1,l.version="2.1.2",l.rotator=c,l.template=d,l.bps=g,l.test=""!==h,l.queue=[],i.type="text/javascript",i.async=!0,i.src="${process.env.ROTATOR}rotator/"+c+"/template/"+d+"?"+(h?"&livetest=1":"")+(g?"&bps="+g:""),k.parentNode.insertBefore(i,k.nextSibling)}}(window,document,'${state.rotator_id}','${state.template_id}');
</script>`
    },
    preloaded(state, getters) {
      return !state.preloading && !state.preloadError && state.preloadUrl
    },
    sdkIdentifiers(state, getters) {
      return state.rotator_id
        ? state.rotator_id + ',' + (state.template_id || '')
        : ''
    },
    // Convert internal representation to SDK format
    getSelectionJson: (state, getters) => () => {
      const json        = {}
      const selectors   = state.sites[state.activeUrl] || {}

      Object.keys(selectors).forEach((field) => {
        selectors[field].forEach((definition) => {
          const step  = 'step' + definition.i
          json[step]  = json[step] || getSelectorTemplate()
          json[step][field].push(definition.c? [definition.s, definition.c]: definition.s)
        })
      })

      return JSON.stringify(json)
    },

    getSelection: (state, getters) => (stageOrder) => {
      if (!state.sites[state.activeUrl])
        return {}

      return state.sites[state.activeUrl]
    }
  },
  // SHOULD UPDATE COMMENT ON THE TOP WHEN CHANGING THE STATE
  state: {
    rotator_id      : false,
    template_id     : false,
    script_location : false,
    data            : false,
    templates       : [],
    preloading      : false,
    preloadError    : false,
    preloadUrl      : false,
    overrideUrl     : false,
    sdkDetection    : false,
    sdkDetected     : false,
    activeUrl       : false,
    livePreview     : false,
    activeType      : -1,
    sites           : {}
  },

  mutations: {
    setRotatorId(state, id) {
      state.rotator_id = id
    },

    setData(state, data) {
      state.data = data
    },

    setTemplateId(state, id) {
      state.template_id = id
    },

    setScriptLocation(state, location) {
      state.script_location = location && location.join("").trim().length
        ? location
        : false
    },

    setTemplates(state, templates) {
      state.templates = templates
    },

    resetRotatorState(state)  {
      state.template_id     = false;
      state.script_location = false;
      state.templates       = [];
      state.preloading      = false;
      state.preloadError    = false;
      state.preloadUrl      = false;
      state.overrideUrl     = false;
      state.sdkDetection    = false;
      state.sdkDetected     = false,
      state.activeUrl       = false;
      state.livePreview     = false;
      state.activeType      = -1;
    },

    // use current site as key for other lists
    setActiveUrl(state, site) {
      state.activeUrl = site

      if (!state.sites[site])
        Vue.set(state.sites, site, getSelectorTemplate())
    },

    // set active panel + el type
    setActiveType(state, index) {
      state.activeType = index
    },

    // preload URL
    setPreloadUrl(state, url) {
      state.preloadUrl = url
    },

    setPreloadingState(state, { status, error }) {
      state.preloading      = status
      state.preloadError    = error
    },

    setOverrideUrl(state, url) {
      state.overrideUrl = url
    },

    sdkDetection(state, bool) {
      state.sdkDetection = bool
    },

    sdkDetected(state, sdk) {
      state.sdkDetected = sdk
    },

    setLivePreview(state, active) {
      state.livePreview = active
    },

    parseElementsFromString(state, sdkString) {
      Vue.set(state.sites, state.activeUrl, JSON.parse(sdkString))
    },
    changeSelection(state, { add, remove }) {
      const payloadsToAdd       = add instanceof Array? add: [add]
      const payloadsToRemove    = remove instanceof Array? remove: [remove]
      const site                = state.sites[state.activeUrl]

      Object.keys(site || {}).map((key) => {
        Vue.set(site, key, site[key].filter((item) => {
          return !payloadsToRemove.some((definition) => item.s == definition.s && item.c == definition.c)
        }))
      })

      if (payloadsToAdd.length) {
        const type = getLabel(payloadsToAdd[0].type)
        Vue.set(site, type, site[type].concat(payloadsToAdd))
      }
    },

    setSelectionJson(state, sdkFormat) {
      if (Object.keys(sdkFormat).length === 0)
        return

      const template = state.sites[state.activeUrl] || getSelectorTemplate()

      Object.keys(sdkFormat).forEach((field) => {
        const match = field.match(/^step([0-9])$/)

        if (match) {
          Object.keys(template).forEach((type) => {
            (sdkFormat[field][type] || []).forEach((element) => {
              const definition = Array.isArray(element)
                ? { s: element[0], c: element[1], i: match[1] }
                : { s: element, c: null, i: match[1] }

              if (!template[type].find((def) => def.s == definition.s && def.c == definition.c))
                template[type].push(definition)
            })
          })
        }
      })

      Vue.set(state.sites, state.activeUrl, template)
    }
  },
  actions: {
    addSelection({ commit, dispatch, state }, payloadOrPayloads) {
      // Remove any existing selection
      commit('setActiveUrl', state.activeUrl)
      commit('changeSelection', { add: payloadOrPayloads, remove: payloadOrPayloads})
    },

    removeSelection({ commit, dispatch, state }, payloadOrPayloads) {
      // Ensure site is initialized
      commit('setActiveUrl', state.activeUrl)
      commit('changeSelection', { add: [], remove: payloadOrPayloads})
    },

    modifySelection({ commit, dispatch, state }, { add, remove }) {
      // Ensure site is initialized
      commit('setActiveUrl', state.activeUrl)
      commit('changeSelection', { add: add, remove: remove})
    },

    setPreloadSettings({ commit, state, getters }, args) {
      if (state.preloadUrl != args.url || !getters.preloaded) {
        commit('setPreloadUrl', args.url || false)
        commit('setPreloadingState', { status: args.status || false, error: args.error || false })
      }
    },

    setActiveUrl({ commit, dispatch, state }, url) {
      if (url != state.activeUrl) {
        commit('setActiveUrl', url)
        commit('setTemplateId', false)
        commit('sdkDetection', false)
        commit('sdkDetected', false)
      }
    },

    setOverrideUrl({ commit, dispatch, state }, url) {
      commit('setOverrideUrl', url)
      commit('setActiveUrl', false)
      commit('setActiveType', -1)
    },

    getRotator({ commit, getters, state }) {
      Vue.$http.get(getters.rotatorBaseEndpoint, {requestId: 'store-rotator-get-rotator', context: Vue._uid})
        .then((response) => {
          commit('setData', response.data.data)
        }).catch((error) => {
          if (Vue.$http.isApiError(error)) {
            commit('setData', false)
          }
        })
    },

    getTemplates({ commit, getters, dispatch, state }, rotatorId) {
      return new Promise((resolve, reject) => {
        Vue.$http.get(getters.rotatorBaseEndpoint + '/templates', {requestId: 'store-rotator-get-templates', context: Vue._uid})
          .then((response) => {
            commit('setTemplates', response.data.data)
            resolve(state.templates)
          }).catch((error) => {
            if (Vue.$http.isApiError(error))
              commit('setTemplates', [])

            resolve(state.templates)
          })
      })
    },

    async setTemplateId({ commit, dispatch, getters, state }, templateId) {
      if (templateId && state.template_id == templateId)
        return

      // See if templates is in the set of affiliate templates
      const template = templateId && (await dispatch('getTemplates')).find((template) => template.id == templateId)

      // Existing template
      if (template) {
        try {
          commit('setTemplateId', templateId)
          commit('setSelectionJson', JSON.parse(template.selector_groups))
        } catch (err) {
          //
        }

      // Otherwise treat this as a new template
      } else {
        const endpoint = getters.rotatorBaseEndpoint + '/template'
        const params   = new URLSearchParams({ selector_groups: '{}' })

        Vue.$http.post(endpoint, params).then((response) => {
          commit('setTemplateId', response.data.data.id)
        }).catch((error) => {
          if (Vue.$http.isApiError(error)) {
            commit('setTemplateId', false)
          }
        })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/rotator.js